import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Program from "./pages/Program";
import Schedule from "./pages/Schedule";
import Coaches from "./pages/Coaches";
import MorningAcademyNachshon from "./pages/MorningAcademyNachshon";
import MorningAcademyEinKarem from "./pages/MorningAcademyEinKarem";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App" dir="rtl">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/program" element={<Program />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/coaches" element={<Coaches />} />
            <Route path="/morning-academy-nachshon" element={<MorningAcademyNachshon />} />
            <Route path="/morning-academy-ein-karem" element={<MorningAcademyEinKarem />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors theme="dark" dir="rtl" />
    </div>
  );
}

export default App;
